import { FirestoreDataConverter } from "firebase/firestore";
import { omit } from "lodash";
import moment from "moment";
import Business from "../models/business";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class BusinessDb extends BaseDb<
  Business,
  { businessId: string }
> {
  _path: string = "business/businessId";
  getConverter(): FirestoreDataConverter<Business> {
    return {
      fromFirestore: (snapshot, _options) =>
        new Business({
          id: snapshot.id,
          nome: snapshot.get("nome"),
          cnpj: snapshot.get("cnpj"),
          imagemUrl: snapshot.get("imagemUrl"),
          principal: snapshot.get("principal"),
          quantidade: snapshot.get("quantidade"),
          dataCriacao: moment(snapshot.get("dataCriacao").toDate()),
        }),
      toFirestore: (business) => toFirestore(omit(business, ["id"])),
    };
  }
}
